export var ODataAction;
(function (ODataAction) {
    ODataAction["Filter"] = "$filter";
    ODataAction["Expand"] = "$expand";
    ODataAction["OrderBy"] = "$orderby";
    ODataAction["Top"] = "$top";
    ODataAction["Select"] = "$select";
})(ODataAction || (ODataAction = {}));
